import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';

export default class AiMessagingIndexRoute extends ProtectedRoute {
  redirect(): void {
    this.router.replaceWith('ai-messaging.knowledge-center');
  }
}
